var path = '/app/components/footer/footer.html';
var html = "<div class=container> <p class=text-muted>v{{ ctrl.version }} | Copyright {{ ctrl.getYear() }} QTH54 Inc. All Rights Reserved</p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.html
// module id = 975
// module chunks = 0